export enum NotificationType {
  LAB_UPDATE = 'LAB_UPDATE',
  NEW_TICKET = 'NEW_TICKET'
}
/*
REF_CASE_UPDATE
LAB_PROFILE_UPDATE
CASE_REF_UPDATE_PATHOLOGIST
REF_CASE_UPDATE_ENDORSEMENT
*/
